import React from "react";
import { colors } from "src/styles";
import { Client, ID } from "src/types";
// import { formatTimezoneToShort } from "src/utils/time";
import styled from "styled-components";
import ClientLogo from "../Logo";

export interface ClientsTableProps {
  isLoading: boolean;
  headers: string[];
  data: Client[];
  onRowClick: (id: ID, name: string) => void;
}

export const ClientTable = ({ isLoading, headers, data, onRowClick }: ClientsTableProps) => {
  if (isLoading) {
    return <EmptyRow>Loading...</EmptyRow>;
  }

  if (!data.length) {
    return <EmptyRow>No Clients assigned</EmptyRow>;
  }

  return (
    <TableWrap>
      <TableHeader>
        {headers.map((header) => (
          <span key={header}>{header}</span>
        ))}
      </TableHeader>
      {data.map(({ id, logo, name }: Client) => {
        return (
          <TableRow key={id} onClick={() => onRowClick(id, name)}>
            <LogoCell>
              <ClientLogo logoFileName={logo} />
            </LogoCell>
            <NameCell>{name}</NameCell>
          </TableRow>
        );
      })}
    </TableWrap>
  );
};

const EmptyRow = styled.div`
  padding: 20px 16px;
  color: ${colors.grey.dark6};
  font-size: 13px;
`;

const TableWrap = styled.div`
  overflow-x: auto;
`;

const TableGridBase = styled.div`
  display: grid;
  grid-template-columns: 96px minmax(220px, 1fr);
  gap: 8px;
  align-items: center;
  min-width: 420px;
`;

const TableHeader = styled(TableGridBase)`
  padding: 12px 16px;
  color: ${colors.grey.dark6};
  border-bottom: 1px solid ${colors.grey.light3};
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
`;

const TableRow = styled(TableGridBase)`
  padding: 14px 16px;
  border-top: 1px solid ${colors.grey.light3};
  cursor: pointer;

  &:hover {
    background: ${colors.grey.light6};
  }
`;

const LogoCell = styled.div`
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NameCell = styled.span`
  font-size: 13px;
  color: ${colors.black.dark1};
`;
